'use client'
import React from 'react';
import { CircleX } from 'lucide-react';
interface CitySelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CitySelectionModal: React.FC<CitySelectionModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/80"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-3xl p-8 mx-4 max-w-md w-full shadow-2xl transform transition-all">
        {/* Close button */}
        <CircleX  onClick={onClose}
          className="text-orange-500 hover:text-orange-600  absolute top-6 right-6 w-8 h-8  flex items-center justify-center  transition-colors cursor-pointer"
          aria-label="Close modal"/>
        
        
        {/* Content */}
        <div className="text-center pt-4">
          {/* Warning icon */}
          <div className="mx-auto w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mb-6">
            <span className="text-3xl">⚠️</span>
          </div>
          
          {/* Title */}
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            SELECT A CITY TO CONTINUE
          </h3>
          
          {/* Message */}
          <p className="text-gray-600 mb-8 text-base leading-relaxed">
            Please select a city first before proceeding with your search.
          </p>
          
          {/* Action button */}
          <button
            onClick={onClose}
            className="w-full bg-[#F05A24] text-white font-bold py-4 px-6 rounded-2xl hover:bg-[#F05A24]/90 transition-colors text-base cursor-pointer"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default CitySelectionModal;
